import type { Component } from 'vue';
import type { FontAwesomeIconProps } from '@fortawesome/vue-fontawesome';

type Callback = () => string | number;

export type Details = {
  title: string;
  value: string | number | undefined | Callback;
  icon: string;
  iconProps?: Partial<Omit<FontAwesomeIconProps, 'icon'>>;
  bgColor?: string;
  fontColor?: string;
  isHidden?: boolean;
};

export enum MemberType {
  User = 'user',
  Group = 'group',
}

export enum ContentTypes {
  Book = 'Book',
  AudioFragment = 'AudioFragment',
  Image = 'Image',
  Article = 'Article',
  GigletsBook = 'GigletsBook',
  Video = 'Video',
  Material = 'Material',
}

export enum TypesToContentTypes {
  BookV1 = 'Book',
  AudioFragmentV1 = 'AudioFragment',
  ImageV1 = 'Image',
  ArticleV1 = 'Article',
  GigletsBookV1 = 'GigletsBook',
  VideoV1 = 'Video',
  MaterialV1 = 'Material',
}

export type ControlButtons = {
  title: string;
  icon: string;
  iconProps?: Partial<Omit<FontAwesomeIconProps, 'icon'>>;
  eventName: string;
  iconColor?: string;
  key?: string;
  isLoading?: boolean;
  isActive?: boolean;
  isHidden?: boolean;
};

export type AdditionalControl = {
  title: string;
  fontColor: string;
  eventName: string;
  icon?: string;
  iconProps?: Partial<Omit<FontAwesomeIconProps, 'icon'>>;
  isHidden?: boolean;
};

export type SharingOptionItems = {
  key: string;
  title: string;
  bgColor: string;
  icon: string;
  customIconComponent?: Component | null;
  size?: number;
  iconSize?: number;
  link?: string;
  callback?: () => void;
  isHidden?: boolean;
};
